import {
  CampaignFilter,
  EnrolmentCreationMethodEnum,
  TargetEnrolmentStatusEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React, { FC } from 'react'
import { plural, Trans } from '@lingui/macro'

import { getFilterTimeFrame } from './getFilterTimeFrame'
import { useTopicTitleQuery } from './TopicEnrolmentFilterHumanizer.codegen'
import {
  renderCreationText,
  renderIncludeArchivedText,
  renderStatusText
} from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'

const TopicTitle: FC<{ id: number }> = ({ id }) => {
  const { data, loading } = useTopicTitleQuery({
    variables: { topicId: id }
  })
  if (loading) {
    return null
  }

  return <>{data?.topic?.currentTitle}</> ?? null
}

export const TopicEnrolmentFilterHumanizer: FC<CampaignFilter> = (filter) => {
  const status = filter.enrolmentFilterSetup
    ?.enrolmentFilterType as TargetEnrolmentStatusEnum

  const creationMethod = filter.enrolmentFilterSetup
    ?.creationMethod as EnrolmentCreationMethodEnum

  const statusText = renderStatusText(status)
  const creationText = renderCreationText(creationMethod)
  const includeArchivedText = renderIncludeArchivedText(
    filter?.enrolmentFilterSetup?.includeArchived || false
  )

  const refIds = filter.ref_ids!
  const resourcesPlural = plural(refIds.length, {
    one: 'resource',
    other: 'resources'
  })

  return (
    <>
      {statusText} <Trans>in</Trans>{' '}
      <strong>
        {refIds.length <= 3
          ? refIds.map((id, index) => {
              return (
                <>
                  <TopicTitle id={id} key={id} />
                  {index === refIds.length - 1 ? '' : ', '}
                </>
              )
            })
          : refIds.length}
      </strong>{' '}
      {resourcesPlural}
      {getFilterTimeFrame(filter)}
      {creationText}
      {includeArchivedText}
    </>
  )
}
